export const ourExpertsData = [
    {
        image: "expertImage1",
        name: "Siddharth Vinayak Patankar",
        designation: "ACKO Drive expert"
    },
    {
        image: "expertImage2",
        name: "Ameya Naik",
        designation: "Chief editor"
    },
    {
        image: "expertImage3",
        name: "Jamshed Avari",
        designation: "Chief editor"
    },
];

export const parameterConsideredData = [
    {
        title: "Under Design (Interior+Exterior)",
        description: "The points given to each model are dependent on how it looks and whether any part of the design contributes to the overall functionality of the car. This also includes the design of the cabin, the colours on offer, and the overall usability."
    },
    {
        title: "Under Performance",
        description: "Under this parameter, the vehicle’s performance is tested, and points are awarded based on its engine and gearbox configuration."
    },
    {
        title: "Under Dynamics, Ride and Handling",
        description: "Is the car comfortable or sporty? That’s the main question here. How is the suspension setup, and does it have body roll? Each car will be judged based on this parameter."
    },
    {
        title: "Under Safety",
        description: "From GNCAP and BNCAP ratings to the number of safety features offered, the Safety parameter is the most important of all. However, the focus is also on what the base variant provides, and each car will be judged accordingly."
    },
    {
        title: "Under Environment and Efficiency",
        description: "Fuel efficiency is one of the most important factors in the car-buying journey. In this parameter, we consider the overall fuel economy, including both highway and city figures. We also evaluate whether the company has taken extra steps to make the car more environmentally friendly, such as offering a mild hybrid, hybrid, or plug-in hybrid option."
    },
    {
        title: "Under Significance To Segment",
        description: "This parameter is crucial because it compares the model to its rivals. Does it offer more or fewer features? Does it set a new benchmark? These are the questions we aim to answer."
    },
    {
        title: "Under Value For Money",
        description: "Is there a significant gap between the price and the features offered, or compared to its rivals? Is the model overpriced for consumers? These are the key markers used to judge this category."
    },
    {
        title: "Under Cabin and Comfort",
        description: "Success in this parameter is measured by the quality of the seats. We assess the comfort they offer, along with the features available in the car. Points are awarded for factors like knee room, headroom, shoulder room, under-thigh support, and lumbar support."
    },
    {
        title: "Under Technology",
        description: "It’s exactly what it sounds like. How tech-packed is the car? That doesn’t mean more tech equals more points. This parameter focuses on how well the technology works and how efficiently it functions. Points are awarded accordingly."
    },
]

export const carPriceRanges = [
    { label: "Cars up to ₹25 lakh", value: "up_to_25_lakh" },
    { label: "Cars from ₹25 - 45 lakh", value: "25_45_lakh" },
    { label: "Cars above ₹45 lakh", value: "above_45_lakh" },
];

export const ratingCriteriaData: { [key: string]: { criterion: string; weightage: string }[] } = {
    "up_to_25_lakh": [
        { criterion: "Design (Exterior + Interior)", weightage: "15%" },
        { criterion: "Performance", weightage: "10%" },
        { criterion: "Dynamics/Ride/Handling", weightage: "10%" },
        { criterion: "Safety", weightage: "15%" },
        { criterion: "Environment/Efficiency", weightage: "5%" },
        { criterion: "Significance to segment", weightage: "15%" },
        { criterion: "Value for money", weightage: "10%" },
        { criterion: "Cabin/Comfort", weightage: "10%" },
        { criterion: "Technology", weightage: "10%" },
    ],
    "25_45_lakh": [
        { criterion: "Design (Exterior + Interior)", weightage: "10%" },
        { criterion: "Performance", weightage: "15%" },
        { criterion: "Dynamics/Ride/Handling", weightage: "10%" },
        { criterion: "Safety", weightage: "10%" },
        { criterion: "Environment/Efficiency", weightage: "10%" },
        { criterion: "Significance to segment", weightage: "10%" },
        { criterion: "Value for money", weightage: "10%" },
        { criterion: "Cabin/Comfort", weightage: "10%" },
        { criterion: "Technology", weightage: "15%" },
    ],
    "above_45_lakh": [
        { criterion: "Design (Exterior + Interior)", weightage: "15%" },
        { criterion: "Performance", weightage: "15%" },
        { criterion: "Dynamics/Ride/Handling", weightage: "15%" },
        { criterion: "Safety", weightage: "5%" },
        { criterion: "Environment/Efficiency", weightage: "5%" },
        { criterion: "Significance to segment", weightage: "10%" },
        { criterion: "Value for money", weightage: "5%" },
        { criterion: "Cabin/Comfort", weightage: "15%" },
        { criterion: "Technology", weightage: "15%" },
    ],
};